export const useUserFullName = (
  name: string | null,
  surname: string | null,
  nickname: string
) => `${name || ""} ${surname || ""}`.trim() || nickname;
